/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Paket_S3Inputs */

const en_tut_paket_s3 = /** @type {(inputs: Tut_Paket_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete the payment in the dialog that appears, then press **Periksa status**.`)
};

const id_tut_paket_s3 = /** @type {(inputs: Tut_Paket_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesaikan pembayaran pada dialog yang muncul, lalu tekan **Periksa status**.`)
};

/**
* | output |
* | --- |
* | "Complete the payment in the dialog that appears, then press **Periksa status**." |
*
* @param {Tut_Paket_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_paket_s3 = /** @type {((inputs?: Tut_Paket_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Paket_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_paket_s3(inputs)
	return en_tut_paket_s3(inputs)
});